// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export { AjaxMonitor as AjaxPlugin } from "./ajax";
export { ajaxRecord } from "./ajaxRecord";
//# sourceMappingURL=applicationinsights-dependencies-js.js.map